import * as CodeMirror from 'codemirror';
require('codemirror/mode/javascript/javascript');
require('codemirror/addon/mode/overlay');



var commentRegex = /\/\//;
var todoRegex = /TODO:.*$/;
const stringPattern = /(\$\(~\s([puv])?:?|\$\()/;

var specialWords = new RegExp(/#expand/);
var hlCustomTagsOpened = new RegExp(/<thinking>|<reasoning>/);
var hlCustomTagsClosed = new RegExp(/<\/thinking>|<\/reasoning>/);
var hlBracketsKeywords = new RegExp(/\[\[(Reasoning|Short-Answer|Images|Has-Answer|Links|Full-Answer)\]\]/);

var hlNa = new RegExp(/(?:\b|^)(N\/a)(?:\b|$)/i);
var hlYes = new RegExp(/(\bYES\b)/);
var hlNo = new RegExp(/(\bNO\b)/);
var hlSourceUrlText = new RegExp(/\[(Source URL)\](?=\([^)]+\))/i);
var hlSourceUrl = new RegExp(/\(([^)]+)\)/i);
var regexpSourceUrl = new RegExp(/\[Source URL\]\(([^)]+)\)/i);

var hlPage = new RegExp(/(>>> page )(?=[\d]+)/i);
var hlNumber = new RegExp(/\s*([\d]+)\s*/i);

const stringClasses = ['string', 'string-2'];

function getMode() {
    return {
        startState: function () {
            return {
                isMultiComment: false,
                isComment: false,
                isSpecialTag: false
            };
        },
        token: function (stream, state) {
            if (stream.pos === 0 && state.isComment) {
                state.isComment = false;
            } else if (state.isSpecialTag) {
                if (
                    stream.match(hlCustomTagsClosed, false)
                ) {
                    stream.match(hlCustomTagsClosed);
                    state.isSpecialTag = false;
                    return 'alan-transform-keyword-bg-green';
                }
                stream.next();
                return 'skip-highlight';
            }
            if (stream.pos === 0 && state.isComment) {
                state.isComment = false;
            }
            if (stream.match(todoRegex)) { //exclude comments
                stream.next();
                return 'todo';
            } else if (stream.match(new RegExp(/:\/\//))) { //exclude :// part of urls
                stream.next();
                return null;
            } else if (stream.match(commentRegex)) { //exclude comments
                state.isComment = true;
                stream.next();
                return null;
            } else if (stream.match('/*')) {//exclude multiline comments
                state.isMultiComment = true;
                stream.next("*/");
                return null;
            } else if (stream.match('*/')) {
                state.isMultiComment = false;
                return null;
            } else {
                if (!state.isMultiComment) {
                    if (!state.isComment) {
                        if (
                            !stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlCustomTagsOpened, false)
                        ) {
                            stream.match(hlCustomTagsOpened);
                            state.isSpecialTag = true;
                            return 'alan-transform-keyword-bg-green';
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlBracketsKeywords)) {
                            return 'alan-transform-keyword-bg-blue';
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlNa)) {
                            return 'alan-transform-keyword-bg-grey';
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlYes)) {
                            return 'alan-transform-keyword-bg-green';
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlPage)) {
                            return 'alan-transform-keyword-bg-blue';
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlNumber)) {
                            const s = stream.string;
                            if (s) {
                                const match = s.match(hlPage);
                                if (match) {
                                    return 'alan-transform-keyword-bg-green';
                                }
                            }
                            return null; 
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlSourceUrl)) {
                            const s = stream.string;
                            if (s) {
                                const match = s.match(regexpSourceUrl);
                                if (match) {
                                    return 'alan-transform-keyword-bg-green';
                                }
                            }
                            return null; 
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlSourceUrlText)) {
                            const s = stream.string;
                            if (s) {
                                const match = s.match(regexpSourceUrl);
                                if (match) {
                                    return 'alan-transform-keyword-bg-blue';
                                }
                            }
                            return null;
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(specialWords)) {
                            return 'alan-transform-keyword-bg-green';
                        }
                        else if (!stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(hlNo)) {
                            return 'alan-transform-keyword-bg-red';
                        }
                        else if (stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(stringPattern)) {
                            return null;
                        }
                        else {
                            stream.next();
                            return null;
                        }
                    } else if (state.isComment) {
                        stream.next();
                        return null;
                    } else {
                        stream.next();
                        return null;
                    }
                } else {
                    stream.next();
                    return null;
                }
            }
        }
    };
}

CodeMirror.defineMode("transformsKeywords-htmlmixed", function (config, parserConfig) {
    const overlay = getMode();
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "htmlmixed"), overlay);
});

CodeMirror.defineMode("transformsKeywords-javascript", function (config, parserConfig) {
    const overlay = getMode();
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "javascript"), overlay);
});

CodeMirror.defineMode("transformsKeywords-json", function (config, parserConfig) {
    const overlay = getMode();
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "json"), overlay);
});

CodeMirror.defineMode("transformsKeywords-text", function (config, parserConfig) {
    const overlay = getMode();
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop), overlay);
});